<div class="embed-container"
     [style.--primary-color]="primaryColor"
     [style.--secondary-color]="secondaryColor">

  <!-- Loading -->
  <div class="embed-loading" *ngIf="loading">
    <div class="loading-spinner"></div>
    <p>Loading leaderboard...</p>
  </div>

  <!-- Error -->
  <div class="embed-error" *ngIf="!loading && error">
    <div class="error-icon">!</div>
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Main Content -->
  <ng-container *ngIf="!loading && !error && currentBoard">
    <!-- Header -->
    <div class="embed-header">
      <img *ngIf="logoUrl" [src]="logoUrl" alt="Group logo" class="group-logo"
           (error)="logoUrl = ''">
      <h1 *ngIf="!logoUrl && schoolName" class="school-name">{{ schoolName }}</h1>
      <h1 class="group-name">{{ groupName }}</h1>
    </div>

    <!-- Board Name -->
    <div class="board-name">{{ currentBoard.Name }}</div>

    <!-- Results Table -->
    <div class="results-table" *ngIf="currentBoard.Results && currentBoard.Results.length > 0">
      <div class="result-row"
           *ngFor="let result of currentBoard.Results | slice:0:10"
           [ngClass]="getRankClass(result.Rank)">
        <div class="result-rank">
          <span class="rank-number">{{ result.Rank }}</span>
        </div>
        <div class="result-name">{{ result.FirstName }} {{ result.LastName }}</div>
        <div class="result-score">{{ formatScore(result.Score, currentBoard.ScoreDecimalPlaces) }}</div>
        <div class="result-class" *ngIf="result.GraduatingClass">'{{ result.GraduatingClass % 100 }}</div>
      </div>
    </div>

    <div class="no-results" *ngIf="!currentBoard.Results || currentBoard.Results.length === 0">
      <p>No results yet.</p>
    </div>

    <!-- Navigation -->
    <div class="nav-bar" *ngIf="leaderboards.length > 1">
      <button class="nav-arrow" (click)="goPrev()" aria-label="Previous leaderboard">&#8249;</button>
      <div class="nav-dots">
        <button *ngFor="let board of leaderboards; let i = index"
                class="nav-dot"
                [class.nav-dot--active]="i === currentIndex"
                (click)="goToBoard(i)"
                [attr.aria-label]="'Go to ' + board.Name">
        </button>
      </div>
      <button class="nav-arrow" (click)="goNext()" aria-label="Next leaderboard">&#8250;</button>
    </div>
  </ng-container>

  <!-- Powered by RackCoach -->
  <div class="powered-by" *ngIf="!loading && !error">
    <span>Powered by</span>
    <img src="/Images/logo-small.png" alt="RackCoach">
  </div>
</div>
